import { render, staticRenderFns } from "./PartnerSettings.vue?vue&type=template&id=1e9bd34c&scoped=true"
import script from "./PartnerSettings.vue?vue&type=script&lang=js"
export * from "./PartnerSettings.vue?vue&type=script&lang=js"
import style0 from "./PartnerSettings.vue?vue&type=style&index=0&id=1e9bd34c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9bd34c",
  null
  
)

export default component.exports